import * as React from "react";
import { Link } from "react-router-dom";
import { demoEntries as relaunchDemos } from "@/data/mockPresentations";
import { sellerAnalysisDemos } from "@/data/sellerAnalysisData";
import { PresentationPage } from "@/components/presentation/PresentationPage";

const demoEntries = [...sellerAnalysisDemos, ...relaunchDemos];

// Internal demo route — NOT for prospects.
export default function Demo() {
  const [activeId, setActiveId] = React.useState(demoEntries[0].id);
  const active = demoEntries.find((e) => e.id === activeId) || demoEntries[0];

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeId]);

  return (
    <div className="bg-ivory">
      <div
        className="sticky top-0 z-[60] border-b border-charcoal/10 bg-ivory/90 backdrop-blur-md"
        data-testid="demo-bar"
      >
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:justify-between md:px-8">
          <div className="flex items-center gap-3">
            <span className="text-xs font-medium uppercase tracking-[0.24em] text-charcoal">
              PitchAI
            </span>
            <span className="rounded-full bg-charcoal px-2.5 py-0.5 text-[0.6rem] uppercase tracking-[0.18em] text-ivory">
              Internal demo
            </span>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {demoEntries.map((entry) => {
              const isActive = entry.id === activeId;
              return (
                <button
                  key={entry.id}
                  type="button"
                  onClick={() => setActiveId(entry.id)}
                  data-testid={`demo-switch-${entry.id}`}
                  aria-pressed={isActive}
                  className={`rounded-full px-4 py-1.5 text-xs uppercase tracking-[0.12em] transition-colors duration-200 ${
                    isActive
                      ? "bg-brass text-charcoal"
                      : "border border-charcoal/20 text-charcoal-soft hover:border-charcoal hover:text-charcoal"
                  }`}
                >
                  {entry.label}
                </button>
              );
            })}
          </div>
        </div>
        <div className="mx-auto w-full max-w-6xl px-4 pb-3 md:px-8">
          <p className="text-xs text-charcoal-muted" data-testid="demo-description">
            <span className="text-charcoal-soft">/p/{active.data.slug}</span>{" "}
            — {active.description}{" "}
            <Link
              to={`/p/${active.data.slug}`}
              className="underline-offset-4 hover:text-charcoal hover:underline"
            >
              Open the real link ↗
            </Link>
          </p>
        </div>
      </div>

      <div data-testid="demo-presentation">
        <PresentationPage key={active.id} data={active.data as any} />
      </div>
    </div>
  );
}
